import { EyeIcon, EyeOffIcon } from 'library/icons';
import React, { FC } from 'react';

interface PasswordEyeProps {
    type: string;
    iconSize?: number;
}

const PasswordEye: FC<PasswordEyeProps> = (props) => {
    const { type, iconSize = 22 } = props;

    if (type === 'password') {
        return <EyeIcon width={iconSize} height={undefined} />;
    } else {
        return <EyeOffIcon width={iconSize} height={undefined} />;
    }
};

export default PasswordEye;
